import { useState, useEffect } from 'react';

const C = {
  green:"#16320f",greenLight:"#1f4516",greenBorder:"#3a7029",
  gold:"#d9c20d",bg:"#0c1e09",surface:"#111f0d",
  text:"#e8f0e6",textMid:"#8faa8a",textDim:"#4a6646",teal:"#34d399",red:"#ef4444",
};

export default function Unsubscribe() {
  const [status, setStatus] = useState("loading"); // loading | success | resubscribed | error
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const token = new URLSearchParams(window.location.search).get("token") || "";
  const action = new URLSearchParams(window.location.search).get("action") || "unsubscribe";

  useEffect(() => {
    if (!token) { setStatus("error"); setErrorMsg("Missing or invalid link."); return; }
    const endpoint = action === "resubscribe" ? "/api/resubscribe" : "/api/unsubscribe";
    fetch(`${endpoint}?token=${encodeURIComponent(token)}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setEmail(data.email || "");
          setStatus(action === "resubscribe" ? "resubscribed" : "success");
        } else {
          setStatus("error");
          setErrorMsg(data.error || "Something went wrong.");
        }
      })
      .catch(() => { setStatus("error"); setErrorMsg("Network error. Please try again."); });
  }, [token, action]);

  const handleResubscribe = () => {
    window.location.href = `/unsubscribe?token=${encodeURIComponent(token)}&action=resubscribe`;
  };

  return (
    <div style={{ minHeight: "100vh", background: C.bg, color: C.text, fontFamily: "Inter,-apple-system,sans-serif", display: "flex", flexDirection: "column" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Mono:wght@400;500&family=Inter:wght@400;500;600&display=swap');*{box-sizing:border-box;}`}</style>

      {/* Header */}
      <div style={{ background: C.greenLight, borderBottom: `2px solid ${C.gold}`, padding: "0 24px", display: "flex", alignItems: "center", gap: 12, minHeight: 56 }}>
        <img src="/warriors-logo.png" style={{ width: 36, height: 36, objectFit: "contain" }} alt="Warrior Academy" onError={e => { e.target.style.display = "none"; }} />
        <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 20, letterSpacing: 4, color: C.gold }}>Warrior Academy</div>
      </div>

      {/* Content */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 20px" }}>
        <div style={{ background: C.surface, border: `1px solid ${C.greenBorder}`, borderRadius: 8, padding: "36px 32px", maxWidth: 480, width: "100%", textAlign: "center" }}>

          {status === "loading" && (
            <div style={{ color: C.textDim, fontSize: 13, letterSpacing: 2 }}>PROCESSING…</div>
          )}

          {status === "success" && (
            <>
              <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
              <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 22, letterSpacing: 3, color: C.text, marginBottom: 12 }}>UNSUBSCRIBED</div>
              <div style={{ fontSize: 14, color: C.textMid, lineHeight: 1.7, marginBottom: 8 }}>
                You have been unsubscribed from Warrior Academy announcements.
              </div>
              {email && <div style={{ fontSize: 12, color: C.textDim, marginBottom: 20 }}>{email}</div>}
              <div style={{ fontSize: 13, color: C.textDim, lineHeight: 1.6, marginBottom: 24, padding: "12px 16px", background: C.bg, borderRadius: 4, border: `1px solid ${C.greenBorder}` }}>
                You will still receive important roster notifications and tournament updates.
              </div>
              <button onClick={handleResubscribe} style={{ background: "transparent", border: `1px solid ${C.gold}55`, color: C.gold, padding: "10px 24px", borderRadius: 4, fontSize: 11, letterSpacing: 1.5, cursor: "pointer", fontFamily: "'DM Mono',monospace" }}>
                RESUBSCRIBE
              </button>
            </>
          )}

          {status === "resubscribed" && (
            <>
              <div style={{ fontSize: 48, marginBottom: 16 }}>🔔</div>
              <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 22, letterSpacing: 3, color: C.teal, marginBottom: 12 }}>RESUBSCRIBED</div>
              <div style={{ fontSize: 14, color: C.textMid, lineHeight: 1.7, marginBottom: 8 }}>
                You have been resubscribed to Warrior Academy announcements.
              </div>
              {email && <div style={{ fontSize: 12, color: C.textDim }}>{email}</div>}
            </>
          )}

          {status === "error" && (
            <>
              <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
              <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 22, letterSpacing: 3, color: C.red, marginBottom: 12 }}>ERROR</div>
              <div style={{ fontSize: 13, color: C.textDim, lineHeight: 1.6 }}>{errorMsg || "Invalid or expired link."}</div>
            </>
          )}

        </div>
      </div>

      <div style={{ textAlign: "center", padding: "16px", fontSize: 11, color: C.textDim }}>
        Warrior Academy · <a href="/" style={{ color: C.textDim }}>warriors-academy-67d1d.web.app</a>
      </div>
    </div>
  );
}
